import { EtaEmitter } from './eta-emitter.enum';
import { DeliveryEventSource } from './delivery-event-source.enum';

// All possible inputs that resulted in ETA
export enum EtaDetailInput {
  PING = 'PING',
  ORIGIN = 'ORIGIN',
  DESTINATION = 'DESTINATION',
  DRIVER = 'DRIVER',
  SAP_ESTIMATE = 'SAP_ESTIMATE',
  UNKNOWN = 'UNKNOWN',
}

export class EtaDetailInputsUtil {

  public static fromEmitter(emitter: EtaEmitter, source: DeliveryEventSource): EtaDetailInput[] {
    switch (emitter) {
      case EtaEmitter.DRIVER:
        return [EtaDetailInput.DRIVER]
      case EtaEmitter.CMBL_AUTOMATIC_ETA:
        switch (source) {
          case DeliveryEventSource.CICO:
            return [EtaDetailInput.ORIGIN, EtaDetailInput.DESTINATION];
          case DeliveryEventSource.CICO_TABLET:
            return [EtaDetailInput.ORIGIN, EtaDetailInput.DESTINATION];
          default:
            return [EtaDetailInput.PING, EtaDetailInput.DESTINATION]
        }
      case EtaEmitter.SAP_PLANNING_PRELOADED:
        return [EtaDetailInput.SAP_ESTIMATE]
      case EtaEmitter.SAP_PGI:
        return [EtaDetailInput.SAP_ESTIMATE]
      case EtaEmitter.EXTERNAL:
      default:
        return [EtaDetailInput.UNKNOWN];

    }
  }
}
